const filterNodeProperties = function(node, keys, defaultData = {}) {
    return keys.reduce(
        (data, key) => {
            return { ...data, [key]: node.attr[key] };
        }, defaultData
    );
};

export {
    filterNodeProperties
};



// WEBPACK FOOTER //
// ./src/js/utilities/filter-node-properties.js